(function () {
  if (window.__erayaChatLoaded) return;
  window.__erayaChatLoaded = true;

  // ── Config ────────────────────────────────────────────────────────────────
  var C = {
    accent:    '#5C1624',
    accentH:   '#45101B',
    bgSoft:    '#F9F6F3',
    bgBlush:   '#F7ECEF',
    text:      '#1C1C1C',
    textMid:   '#6B6B6B',
    textLight: '#A8A8A8',
    border:    '#EBEBEB',
    waNumber:  '919157244478',
    apiUrl:    'https://ggzxyacfllkelnflcugz.supabase.co/functions/v1/website-chatbot',
  };

  // ── State ─────────────────────────────────────────────────────────────────
  var history      = [];
  var pendingImage = null; // { dataUrl, base64, mimeType }
  var isOpen       = false;
  var isBusy       = false;
  var _panelReady  = false;
  var _justOpened  = false;

  // ── Team members ──────────────────────────────────────────────────────────
  var TEAM = [
    { name: 'Priya',   img: 'https://cdn.shopify.com/s/files/1/0688/5215/4591/files/image-1.png?v=1777961822' },
    { name: 'Anjali',  img: 'https://cdn.shopify.com/s/files/1/0688/5215/4591/files/image-2.png?v=1777961822' },
    { name: 'Meghna',  img: 'https://cdn.shopify.com/s/files/1/0688/5215/4591/files/image-3.png?v=1777961822' },
  ];
  var assignedAgent = TEAM[Math.floor(Math.random() * TEAM.length)];

  // ── Session persistence (localStorage, 7-day expiry) ─────────────────────
  var LS_KEY = 'eraya_chat';
  var sessionId;
  try {
    var _s = JSON.parse(localStorage.getItem(LS_KEY) || 'null');
    if (_s && (Date.now() - (_s.ts || 0)) < 7 * 86400000 && _s.history && _s.history.length) {
      sessionId = _s.sessionId;
      history   = _s.history;
    }
  } catch (e) {}
  if (!sessionId) sessionId = 'ws-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9);

  // ── AI call ───────────────────────────────────────────────────────────────
  function callAI(text, image, onReply) {
    var payload = {
      message:   text || 'I am sharing a photo.',
      history:   history,
      sessionId: sessionId,
      pageUrl:   window.location.href,
    };
    if (image) payload.image = { data: image.base64, mimeType: image.mimeType };

    fetch(C.apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var reply    = data.reply   || 'Sorry, something went wrong. Please try again.';
        var escalate = !!data.escalate;
        history.push({ role: 'user',  text: text || '[photo shared]' });
        history.push({ role: 'model', text: reply });
        try { localStorage.setItem(LS_KEY, JSON.stringify({ sessionId: sessionId, history: history, ts: Date.now() })); } catch (e) {}
        onReply(reply, escalate);
      })
      .catch(function () {
        onReply("I'm having a little trouble right now. Please WhatsApp us at +91 9157244478 — we'll sort it out!", true);
      });
  }

  // ── Styles ────────────────────────────────────────────────────────────────
  var css = [
    '#ec-btn{position:fixed;bottom:24px;right:24px;z-index:9999;',
    'width:56px;height:56px;border-radius:50%;',
    'background:' + C.accent + ';border:none;cursor:pointer;',
    'display:flex;align-items:center;justify-content:center;',
    'box-shadow:0 4px 20px rgba(92, 22, 36,0.45);',
    'transition:background .2s ease,transform .2s ease;}',
    '#ec-btn:hover{background:' + C.accentH + ';transform:scale(1.06);}',
    '#ec-btn svg{width:20px;height:20px;fill:none;stroke:#fff;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;}',
    '#ec-dot{position:absolute;top:-3px;right:-3px;width:10px;height:10px;',
    'background:#ef4444;border-radius:50%;border:2px solid #fff;display:none;',
    'animation:ec-dot-pulse 1.6s ease infinite;}',

    '#ec-win{position:fixed;bottom:92px;right:24px;z-index:9998;',
    'width:360px;max-height:500px;height:500px;',
    'background:#fff;border:1px solid ' + C.border + ';border-radius:18px;',
    'box-shadow:0 8px 40px rgba(28,28,28,0.13);',
    'display:flex;flex-direction:column;',
    "font-family:'Jost',sans-serif;overflow:hidden;",
    'transform:translateY(12px) scale(0.97);opacity:0;pointer-events:none;',
    'transition:transform .22s ease,opacity .18s ease;}',
    '#ec-win.open{transform:translateY(0) scale(1);opacity:1;pointer-events:all;}',
    '#ec-win.open~#ec-btn{display:none!important;}',

    /* Header */
    '#ec-hd{background:' + C.bgSoft + ';padding:16px 20px;',
    'display:flex;align-items:center;gap:12px;',
    'flex-shrink:0;border-bottom:1px solid ' + C.border + ';}',
    '#ec-hd-avatars{display:flex;align-items:center;flex-shrink:0;}',
    '.ec-hd-av{width:34px;height:34px;border-radius:50%;object-fit:cover;',
    'border:2px solid ' + C.bgSoft + ';margin-left:-10px;}',
    '.ec-hd-av:first-child{margin-left:0;}',
    '#ec-hd-info{flex:1;min-width:0;}',
    "#ec-hd-name{font-family:'Cormorant Garamond',serif;font-size:17px;",
    'font-weight:400;letter-spacing:0.04em;color:' + C.text + ';line-height:1.2;}',
    '#ec-hd-status{font-size:10px;font-weight:400;letter-spacing:0.15em;',
    'text-transform:uppercase;color:' + C.accent + ';',
    'display:flex;align-items:center;gap:5px;margin-top:2px;}',
    "#ec-hd-status::before{content:'';width:6px;height:6px;",
    'background:#4ade80;border-radius:50%;display:inline-block;flex-shrink:0;}',

    /* Messages */
    '#ec-msgs{flex:1;overflow-y:auto;padding:16px 16px 8px;',
    'display:flex;flex-direction:column;gap:12px;background:#fff;}',
    '#ec-msgs::-webkit-scrollbar{width:3px;}',
    '#ec-msgs::-webkit-scrollbar-track{background:transparent;}',
    '#ec-msgs::-webkit-scrollbar-thumb{background:' + C.border + ';}',
    '#ec-msgs::-webkit-scrollbar-thumb:hover{background:' + C.accent + ';}',
    '.ec-m{max-width:84%;display:flex;flex-direction:column;gap:4px;}',
    '.ec-m.bot{align-self:flex-start;animation:ec-fadein 0.22s ease both;}',
    '.ec-m.user{align-self:flex-end;}',
    '.ec-b{padding:11px 14px;font-size:13px;line-height:1.6;color:' + C.text + ';}',
    '.ec-b a{color:' + C.accent + ';word-break:break-all;text-underline-offset:2px;}',
    '.ec-b a:hover{color:' + C.accentH + ';}',
    '.ec-m.bot .ec-b{background:#fff;border:1px solid ' + C.border + ';border-radius:14px;border-bottom-left-radius:3px;}',
    '.ec-m.user .ec-b{background:' + C.accent + ';color:#fff;border:none;border-radius:14px;border-bottom-right-radius:3px;}',
    '.ec-m.user .ec-b a{color:#fff;opacity:.85;}',
    '.ec-img-bubble{padding:6px;background:#fff;border:1px solid ' + C.border + ';border-radius:14px;border-bottom-right-radius:3px;}',
    '.ec-img-bubble img{display:block;max-width:200px;border-radius:10px;}',
    '.ec-t{font-size:10px;color:' + C.textLight + ';letter-spacing:0.03em;padding:0 2px;}',
    '.ec-m.user .ec-t{text-align:right;}',

    /* WA button */
    '.ec-wa{margin-top:8px;display:inline-flex;align-items:center;gap:7px;',
    'background:#25D366;color:#fff;border:none;border-radius:20px;',
    "padding:8px 14px;font-size:12px;font-family:'Jost',sans-serif;",
    'font-weight:500;letter-spacing:0.04em;cursor:pointer;text-decoration:none;transition:background .2s;}',
    '.ec-wa:hover{background:#1ebe5d;}',
    '.ec-wa svg{width:15px;height:15px;flex-shrink:0;}',

    /* Agent joined */
    '.ec-joined{display:flex;align-items:center;gap:8px;align-self:center;',
    'font-size:11px;color:' + C.textLight + ';letter-spacing:0.04em;margin:4px 0;}',
    '.ec-joined img{width:20px;height:20px;border-radius:50%;object-fit:cover;flex-shrink:0;}',

    /* Typing dots */
    '.ec-typing-wrap{align-self:flex-start;}',
    '.ec-dots{display:flex;align-items:center;gap:4px;',
    'padding:12px 14px;background:#fff;border:1px solid ' + C.border + ';}',
    '.ec-dots span{width:6px;height:6px;background:' + C.accent + ';border-radius:50%;animation:ec-pulse .9s infinite;}',
    '.ec-dots span:nth-child(2){animation-delay:.2s;}',
    '.ec-dots span:nth-child(3){animation-delay:.4s;}',
    '@keyframes ec-pulse{0%,80%,100%{opacity:.3;transform:scale(0.85);}40%{opacity:1;transform:scale(1);}}',
    '@keyframes ec-fadein{from{opacity:0;transform:translateY(6px);}to{opacity:1;transform:translateY(0);}}',
    '@keyframes ec-dot-pulse{0%,100%{transform:scale(1);box-shadow:0 0 0 0 rgba(239,68,68,0.5);}50%{transform:scale(1.2);box-shadow:0 0 0 5px rgba(239,68,68,0);}}',

    /* Quick chips */
    '#ec-chips{padding:8px 12px 6px;display:flex;flex-wrap:nowrap;gap:6px;overflow-x:auto;',
    'background:#fff;border-top:1px solid ' + C.border + ';flex-shrink:0;',
    '-webkit-overflow-scrolling:touch;}',
    '#ec-chips::-webkit-scrollbar{display:none;}',
    '.ec-chip{background:' + C.bgBlush + ';border:1px solid ' + C.border + ';',
    'color:' + C.textMid + ';padding:4px 9px;white-space:nowrap;flex-shrink:0;',
    'display:inline-flex;align-items:center;gap:4px;',
    "font-size:11px;font-family:'Jost',sans-serif;font-weight:400;letter-spacing:0.02em;",
    'cursor:pointer;border-radius:20px;transition:background .15s,border-color .15s,color .15s;}',
    '.ec-chip:hover{background:' + C.bgSoft + ';border-color:' + C.accent + ';color:' + C.text + ';}',
    '.ec-chip svg{width:11px;height:11px;fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;flex-shrink:0;}',

    /* ── Paste preview row ─────────────────────────────────────────────── */
    '#ec-paste-row{display:none;align-items:center;gap:10px;',
    'padding:8px 12px;background:' + C.bgSoft + ';',
    'border-top:1px solid ' + C.border + ';flex-shrink:0;}',
    '#ec-paste-row.show{display:flex;}',
    '#ec-paste-thumb{width:52px;height:52px;border-radius:8px;',
    'object-fit:cover;border:1px solid ' + C.border + ';flex-shrink:0;}',
    '#ec-paste-label{flex:1;min-width:0;}',
    '#ec-paste-label span{display:block;font-size:11.5px;color:' + C.textMid + ';letter-spacing:.02em;}',
    '#ec-paste-label strong{font-size:12px;font-weight:500;color:' + C.text + ';}',
    '#ec-paste-clear{width:24px;height:24px;border-radius:50%;',
    'background:' + C.border + ';border:none;cursor:pointer;',
    'display:flex;align-items:center;justify-content:center;flex-shrink:0;',
    'transition:background .15s;}',
    '#ec-paste-clear:hover{background:#D1D5DB;}',
    '#ec-paste-clear svg{width:10px;height:10px;stroke:#6B6B6B;stroke-width:2.2;fill:none;}',

    /* Input row */
    '#ec-input-row{display:flex;align-items:center;gap:8px;',
    'border-top:1px solid ' + C.border + ';background:#fff;flex-shrink:0;padding:10px 12px;}',
    '#ec-photo{width:36px;height:36px;border-radius:50%;background:none;',
    'border:1.5px solid ' + C.border + ';cursor:pointer;',
    'display:flex;align-items:center;justify-content:center;flex-shrink:0;',
    'transition:border-color .15s,background .15s;}',
    '#ec-photo:hover{border-color:' + C.accent + ';background:' + C.bgBlush + ';}',
    '#ec-photo svg{width:15px;height:15px;fill:none;stroke:' + C.textMid + ';stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round;}',
    '#ec-photo:hover svg{stroke:' + C.accent + ';}',
    '#ec-input{flex:1;height:40px;border:1px solid ' + C.border + ';',
    'border-radius:20px;padding:0 16px;',
    /* 16px minimum prevents iOS Safari from auto-zooming on focus */
    "font-size:16px;font-family:'Jost',sans-serif;font-weight:300;",
    'color:' + C.text + ';outline:none;background:' + C.bgSoft + ';',
    'letter-spacing:0.02em;transition:border-color .15s;}',
    '#ec-input:focus{border-color:' + C.border + ';background:#fff;outline:none;box-shadow:none;}',
    '#ec-input::placeholder{color:' + C.textLight + ';font-size:14px;}',
    '#ec-send{width:40px;height:40px;border-radius:50%;background:' + C.accent + ';border:none;',
    'cursor:pointer;display:flex;align-items:center;justify-content:center;',
    'flex-shrink:0;transition:background .2s;}',
    '#ec-send:hover{background:' + C.accentH + ';}',
    '#ec-send svg{width:15px;height:15px;fill:none;stroke:#fff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}',

    /* Footer branding */
    '#ec-footer{display:flex;align-items:center;justify-content:center;',
    'padding:7px 14px calc(7px + env(safe-area-inset-bottom));',
    'background:#fff;flex-shrink:0;}',
    '#ec-footer-brand{display:flex;align-items:center;gap:5px;}',
    '#ec-footer svg{width:11px;height:11px;fill:none;stroke:' + C.textLight + ';stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round;flex-shrink:0;}',
    '#ec-footer span{font-size:10px;color:' + C.textLight + ';letter-spacing:0.05em;}',
    '#ec-close{background:none;border:none;cursor:pointer;padding:2px 0;margin-left:auto;',
    'font-size:10.5px;color:' + C.text + ';letter-spacing:0.06em;text-transform:uppercase;',
    "font-family:'Jost',sans-serif;transition:color .15s;}",
    '#ec-close:hover{color:' + C.text + ';}',

    '@media(max-width:480px){',
    '#ec-btn{bottom:calc(60px + env(safe-area-inset-bottom) + 10px);left:16px;width:46px;height:46px;}',
    '#ec-btn svg{width:17px;height:17px;}',
    '#ec-win{left:0;right:0;top:0;bottom:0;width:auto;height:auto;max-height:none;border-radius:0;}',
    '}',
  ].join('');

  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  // ── HTML ──────────────────────────────────────────────────────────────────
  var el = document.createElement('div');
  el.innerHTML = [
    '<div id="ec-win">',

      '<div id="ec-hd">',
        '<div id="ec-hd-avatars">',
          '<img src="https://cdn.shopify.com/s/files/1/0688/5215/4591/files/image-3.png?v=1777961822" class="ec-hd-av" alt="">',
          '<img src="https://cdn.shopify.com/s/files/1/0688/5215/4591/files/image-1.png?v=1777961822" class="ec-hd-av" alt="">',
          '<img src="https://cdn.shopify.com/s/files/1/0688/5215/4591/files/image-2.png?v=1777961822" class="ec-hd-av" alt="">',
        '</div>',
        '<div id="ec-hd-info">',
          '<div id="ec-hd-name">Eraya Style</div>',
          '<div id="ec-hd-status">Our team is online</div>',
        '</div>',
        '<button id="ec-close">Close</button>',
      '</div>',

      '<div id="ec-msgs"></div>',

      '<div id="ec-chips">',
        '<button class="ec-chip" data-msg="Where is my order?"><svg viewBox="0 0 24 24"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>Track order</button>',
        '<button class="ec-chip" data-msg="What is the delivery time?"><svg viewBox="0 0 24 24"><rect x="1" y="3" width="15" height="13" rx="1"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>Delivery</button>',
        '<button class="ec-chip" data-msg="Tell me about personalised jewellery"><svg viewBox="0 0 24 24"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>Personalise</button>',
        '<button class="ec-chip" data-msg="What are your payment options?"><svg viewBox="0 0 24 24"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>Payment</button>',
      '</div>',

      /* Paste/attach preview — hidden until image is staged */
      '<div id="ec-paste-row">',
        '<img id="ec-paste-thumb" src="" alt="preview">',
        '<div id="ec-paste-label">',
          '<strong>Photo attached</strong>',
          '<span>Add a message or send as-is</span>',
        '</div>',
        '<button id="ec-paste-clear" title="Remove photo">',
          '<svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
        '</button>',
      '</div>',

      '<div id="ec-input-row">',
        '<button id="ec-photo" title="Attach a photo">',
          '<svg viewBox="0 0 24 24">',
            '<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>',
            '<circle cx="12" cy="13" r="4"/>',
          '</svg>',
        '</button>',
        '<input type="file" id="ec-file" accept="image/*" style="display:none">',
        '<input id="ec-input" type="text" placeholder="Ask us anything…" autocomplete="off" />',
        '<button id="ec-send">',
          '<svg viewBox="0 0 24 24"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>',
        '</button>',
      '</div>',

      '<div id="ec-footer">',
        '<div id="ec-footer-brand">',
          '<svg viewBox="0 0 24 24"><path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3z"/><path d="M3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/></svg>',
          '<span>Eraya Style Support</span>',
        '</div>',
      '</div>',

    '</div>',

    '<button id="ec-btn" title="Chat with us">',
      '<div id="ec-dot"></div>',
      '<svg viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>',
    '</button>',
  ].join('');
  document.body.appendChild(el);

  // ── Refs ──────────────────────────────────────────────────────────────────
  var win        = document.getElementById('ec-win');
  var btn        = document.getElementById('ec-btn');
  var dot        = document.getElementById('ec-dot');
  var msgs       = document.getElementById('ec-msgs');
  var input      = document.getElementById('ec-input');
  var sendBtn    = document.getElementById('ec-send');
  var closeBtn   = document.getElementById('ec-close');
  var photoBtn   = document.getElementById('ec-photo');
  var fileInput  = document.getElementById('ec-file');
  var pasteRow   = document.getElementById('ec-paste-row');
  var pasteThumb = document.getElementById('ec-paste-thumb');
  var pasteClear = document.getElementById('ec-paste-clear');

  // ── Helpers ───────────────────────────────────────────────────────────────
  function ts() {
    var d = new Date();
    return d.getHours() + ':' + String(d.getMinutes()).padStart(2, '0');
  }

  function md(text) {
    var parts = text.split(/(https?:\/\/[^\s]+)/g);
    return parts.map(function (part, i) {
      if (i % 2 === 1) {
        return '<a href="' + part + '" target="_blank" rel="noopener">' + part + '</a>';
      }
      return part
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    }).join('');
  }

  function waHref(lastMsg) {
    var q = 'Hi! I need help' + (lastMsg ? ' with: ' + lastMsg : '.');
    return 'https://wa.me/' + C.waNumber + '?text=' + encodeURIComponent(q);
  }

  function addMsg(text, who, showWA) {
    var wrap = document.createElement('div');
    wrap.className = 'ec-m ' + who;
    var bubble = document.createElement('div');
    bubble.className = 'ec-b';
    bubble.innerHTML = md(text);
    wrap.appendChild(bubble);
    if (showWA) {
      var wa = document.createElement('a');
      wa.className = 'ec-wa';
      wa.href = 'https://wa.me/' + C.waNumber + '?text=' + encodeURIComponent('Hi! I need help from the Eraya Style team.');
      wa.target = '_blank';
      wa.rel = 'noopener';
      wa.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg> Chat on WhatsApp';
      wrap.appendChild(wa);
    }
    var time = document.createElement('div');
    time.className = 'ec-t'; time.textContent = ts();
    wrap.appendChild(time);
    msgs.appendChild(wrap);
    msgs.scrollTop = msgs.scrollHeight;
  }

  function addImgBubble(dataUrl) {
    var wrap = document.createElement('div');
    wrap.className = 'ec-m user';
    var bubble = document.createElement('div');
    bubble.className = 'ec-img-bubble';
    var img = document.createElement('img');
    img.src = dataUrl; img.alt = 'Shared photo';
    bubble.appendChild(img); wrap.appendChild(bubble);
    var time = document.createElement('div');
    time.className = 'ec-t'; time.textContent = ts();
    wrap.appendChild(time);
    msgs.appendChild(wrap);
    msgs.scrollTop = msgs.scrollHeight;
  }

  function showTyping() {
    var wrap = document.createElement('div');
    wrap.className = 'ec-m bot ec-typing-wrap'; wrap.id = 'ec-typing';
    wrap.innerHTML = '<div class="ec-dots"><span></span><span></span><span></span></div>';
    msgs.appendChild(wrap); msgs.scrollTop = msgs.scrollHeight;
  }

  function hideTyping() { var t = document.getElementById('ec-typing'); if (t) t.remove(); }

  function setBusy(busy) {
    isBusy = busy;
    sendBtn.disabled = busy; photoBtn.disabled = busy; input.disabled = busy;
    sendBtn.style.opacity = busy ? '0.6' : '1';
    photoBtn.style.opacity = busy ? '0.6' : '1';
  }

  // ── Pending image management ──────────────────────────────────────────────
  function compressImage(file, cb) {
    var reader = new FileReader();
    reader.onload = function (e) {
      var img = new Image();
      img.onload = function () {
        var maxW = 800, maxH = 800, w = img.width, h = img.height;
        if (w > maxW) { h = Math.round(h * maxW / w); w = maxW; }
        if (h > maxH) { w = Math.round(w * maxH / h); h = maxH; }
        var canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        var dataUrl = canvas.toDataURL('image/jpeg', 0.82);
        cb(dataUrl, dataUrl.split(',')[1], 'image/jpeg');
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  function setPendingImage(file) {
    compressImage(file, function (dataUrl, base64, mimeType) {
      pendingImage = { dataUrl: dataUrl, base64: base64, mimeType: mimeType };
      pasteThumb.src = dataUrl;
      pasteRow.classList.add('show');
      input.placeholder = 'Add a message (optional)…';
      input.focus();
    });
  }

  function clearPendingImage() {
    pendingImage = null;
    pasteThumb.src = '';
    pasteRow.classList.remove('show');
    input.placeholder = 'Ask us anything…';
    fileInput.value = '';
  }

  // ── Send ──────────────────────────────────────────────────────────────────
  function send(text) {
    text = (text || '').trim();
    if (!text && !pendingImage) return;
    if (isBusy) return;

    if (pendingImage) addImgBubble(pendingImage.dataUrl);
    if (text) addMsg(text, 'user');

    var imgToSend = pendingImage;
    input.value = '';
    clearPendingImage();
    setBusy(true);
    showTyping();

    callAI(text, imgToSend, function (reply, escalate) {
      var humanDelay = 1200 + Math.floor(Math.random() * 1400);
      setTimeout(function () {
        hideTyping();
        addMsg(reply, 'bot', escalate);
        setBusy(false);
        input.focus();
      }, humanDelay);
    });
  }

  function _lockScroll() { window.scrollTo(0, 0); }

  window.__erayaChatOpen = function () { openChat(); };

  function openChat() {
    _justOpened = true;
    setTimeout(function () { _justOpened = false; }, 50);
    isOpen = true; win.classList.add('open');
    document.body.style.overflow = 'hidden';
    window.addEventListener('scroll', _lockScroll, { passive: true });
    if (dot) dot.style.display = 'none';
    if (!_panelReady) {
      _panelReady = true;
      if (history.length) {
        history.forEach(function (m) { addMsg(m.text, m.role === 'user' ? 'user' : 'bot'); });
        setTimeout(function () { msgs.scrollTop = msgs.scrollHeight; }, 50);
      } else {
        setTimeout(function () {
          var joined = document.createElement('div');
          joined.className = 'ec-joined';
          joined.innerHTML = '<img src="' + assignedAgent.img + '" alt=""><span>' + assignedAgent.name + ' joined the chat</span>';
          msgs.appendChild(joined);
          msgs.scrollTop = msgs.scrollHeight;
        }, 400);
        setTimeout(function () { showTyping(); }, 900);
        setTimeout(function () {
          hideTyping();
          addMsg('Hi! How can we help you today? Ask about your order, delivery, personalisation, or anything else.', 'bot');
        }, 2200);
      }
    }
    setTimeout(function () { input.focus(); }, 350);
  }

  function closeChat() {
    isOpen = false; win.classList.remove('open');
    document.body.style.overflow = '';
    window.removeEventListener('scroll', _lockScroll);
  }

  // ── Events ────────────────────────────────────────────────────────────────
  btn.addEventListener('click', function () { isOpen ? closeChat() : openChat(); });
  closeBtn.addEventListener('click', closeChat);

  document.addEventListener('click', function (e) {
    if (_justOpened) return;
    if (isOpen && !win.contains(e.target) && !btn.contains(e.target)) closeChat();
  });
  sendBtn.addEventListener('click', function () { send(input.value); });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(input.value); }
  });
  input.addEventListener('focus', function () {
    setTimeout(function () {
      window.scrollTo(0, 0);
      msgs.scrollTop = msgs.scrollHeight;
    }, 150);
  });

  /* File picker */
  photoBtn.addEventListener('click', function () { fileInput.click(); });
  fileInput.addEventListener('change', function () {
    if (fileInput.files && fileInput.files[0]) setPendingImage(fileInput.files[0]);
  });

  /* Clear pending image */
  pasteClear.addEventListener('click', clearPendingImage);

  /* Paste image — Ctrl+V anywhere inside the chat window OR directly into input */
  function handlePaste(e) {
    var items = (e.clipboardData || (e.originalEvent && e.originalEvent.clipboardData) || {}).items;
    if (!items) return;
    for (var i = 0; i < items.length; i++) {
      if (items[i].type.indexOf('image') !== -1) {
        e.preventDefault();
        var file = items[i].getAsFile();
        if (file) setPendingImage(file);
        return;
      }
    }
  }
  input.addEventListener('paste', handlePaste);
  win.addEventListener('paste', handlePaste);

  /* Quick chips */
  document.querySelectorAll('.ec-chip').forEach(function (c) {
    c.addEventListener('click', function () { send(c.getAttribute('data-msg')); });
  });

  /* Notification dot */
  setTimeout(function () {
    if (!isOpen) { var d = document.getElementById('ec-dot'); if (d) d.style.display = 'block'; }
  }, 5000);

  /* Keyboard height — shrink window bottom so input stays above keyboard.
     Scroll lock (above) keeps header pinned. This shrinks the window only. */
  if (window.visualViewport) {
    var _initVvH = window.visualViewport.height;
    window.visualViewport.addEventListener('resize', function () {
      if (!isOpen) return;
      var kbH = Math.max(0, Math.round(_initVvH - window.visualViewport.height));
      win.style.bottom = kbH > 80 ? kbH + 'px' : '';
      setTimeout(function () { msgs.scrollTop = msgs.scrollHeight; }, 50);
    });
  }

})();
